import {
  deliveryInspection,
  deliveryInspectionPage,
  type DeliveryInspectionQuery,
} from '@dental-staffing-platform/shared';
import { req } from './admin-client.js';

export const deliveryAdminApi = {
  async list(query: DeliveryInspectionQuery) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      if (value !== undefined && value !== '') params.set(key, String(value));
    }
    return deliveryInspectionPage.parse(await req(`/api/admin/message-deliveries?${params}`));
  },
  async get(id: string) {
    return deliveryInspection.parse(
      await req(`/api/admin/message-deliveries/${encodeURIComponent(id)}`)
    );
  },
};
